import { render, staticRenderFns } from "./InvoiceListDesktopView.vue?vue&type=template&id=01456aed&"
import script from "./InvoiceListDesktopView.vue?vue&type=script&lang=js&"
export * from "./InvoiceListDesktopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports